var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.32 7.47c.02.32.02.65.02.98 0 10-7.62 21.55-21.55 21.55A21.5 21.5 0 0 1 .18 26.6a15.21 15.21 0 0 0 11.21-3.14A7.58 7.58 0 0 1 4.3 18.2a7.6 7.6 0 0 0 3.42-.13 7.58 7.58 0 0 1-6.07-7.43v-.1a7.4 7.4 0 0 0 3.43.96A7.58 7.58 0 0 1 2.75 1.38 21.5 21.5 0 0 0 18.36 9.3a7.58 7.58 0 0 1 12.9-6.91A15.2 15.2 0 0 0 36.09.55a7.6 7.6 0 0 1-3.33 4.19c1.5-.18 2.97-.58 4.35-1.2a15.39 15.39 0 0 1-3.78 3.93Z"
  })));
};
export default SvgTwitter;